import type { ConsentType } from './types';

/** Every consent, in the order the registration form and the child screen list them (Q23, Q45). */
export const CONSENT_TYPES: readonly ConsentType[] =
  ['IndividualPhotos', 'GroupPhotos', 'Outings', 'EmergencyMedicalTreatment'];
